<template>
  <div :class="['play-overlay', { playing: isPlaying }]" role="button" tabindex="0" @click="onClick" @keyup.enter="onClick">
    <div class="overlay-bg"></div>
    <div class="icon">
      <i :class="isPlaying ? 'bi bi-pause-fill' : 'bi bi-play-fill'"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayButton',
  props: {
    isPlaying: { type: Boolean, default: false },
    size: { type: Number, default: 48 }
  },
  methods: {
    onClick() {
      this.$emit('toggle');
    }
  }
}
</script>

<style scoped>
.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  cursor: pointer;
  z-index: 2;
  transition: opacity 160ms ease, transform 160ms ease;
}
.overlay-bg {
  position: absolute;
  inset: 0;
  background: #2f2f2f6f;
  border-radius: 50%;
  backdrop-filter: blur(1px);
}
.icon {
  position: relative;
  color: #fff;
  font-size: 2rem;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
}
.play-overlay.playing {
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, -50%) scale(0.9);
}
</style>